import { useNavigate } from "@tanstack/react-router";

import { useRecordDetailsPanel } from "@/pages/home/components/RecordDetailsPanelContext";

export function useOpenLeadPanel() {
    const navigate = useNavigate();
    const leadPanel = useRecordDetailsPanel();

    return (leadId: string) => {
        navigate({
            to: "/",
            replace: true,
        });
        setTimeout(() => {
            leadPanel?.open(String(leadId), "Leads");
        }, 0);
    };
}
